/* Wildland Blades — landing page behaviour
   Scroll reveals, path drawing, sticky header, AJAX add-to-cart + toast, mobile drawer. */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------------------------------------------------------- reveals */
  function initReveals(scope) {
    var nodes = (scope || document).querySelectorAll('[data-reveal]:not([data-wl-seen]), [data-draw]:not([data-wl-seen])');
    if (!nodes.length) return;

    if (reduce || !('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(nodes, function (el) {
        el.setAttribute('data-wl-seen', '1');
        if (el.hasAttribute('data-draw')) el.style.strokeDashoffset = '0';
        else el.classList.add('wl-in');
      });
      return;
    }

    if (!window.__wlObserver) {
      window.__wlObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          if (el.hasAttribute('data-draw')) el.style.strokeDashoffset = '0';
          else el.classList.add('wl-in');
          window.__wlObserver.unobserve(el);
        });
      }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 });
    }

    Array.prototype.forEach.call(nodes, function (el) {
      el.setAttribute('data-wl-seen', '1');
      if (el.hasAttribute('data-draw')) {
        var len = 1200;
        try { len = el.getTotalLength(); } catch (e) {}
        el.style.strokeDasharray = len;
        el.style.strokeDashoffset = len;
        el.style.transition = 'stroke-dashoffset 2.1s cubic-bezier(.22,.7,.3,1)';
      } else {
        el.style.transitionDelay = (el.getAttribute('data-delay') || 0) + 'ms';
      }
      window.__wlObserver.observe(el);
    });
  }

  /* ---------------------------------------------------------- sticky header */
  function initHeader() {
    var header = document.querySelector('[data-wl-header]');
    if (!header) return;
    var onScroll = function () {
      var y = window.scrollY || document.documentElement.scrollTop || 0;
      header.classList.toggle('wl-header--stuck', y > 70);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ------------------------------------------------------------ hero video */
  /* The <video> streams from a plain src, which is what you want on Shopify's CDN.
     The fallback below fires only if that fails — a server that does not advertise
     Accept-Ranges cannot serve the tail of an mp4 whose moov atom sits at the end,
     and the element ends up in NETWORK_NO_SOURCE with nothing on screen but the
     poster. Only then do we fetch the file whole and play it from a blob. */
  function initVideo() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-wl-video]'), function (v) {
      v.muted = true;
      v.defaultMuted = true;
      v.loop = true;
      var play = function () {
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      };
      play();

      if (v.__wlBound) return;
      v.__wlBound = true;
      var path = v.getAttribute('src') || (v.querySelector('source') || {}).src;
      if (!path || !window.fetch) return;

      /* Looping is asserted three ways, because the loop attribute alone is not
         reliable once a blob is the source: the attribute, a restart on 'ended',
         and a resume when the tab comes back into view. */
      v.addEventListener('ended', function () { v.currentTime = 0; play(); });
      document.addEventListener('visibilitychange', function () {
        if (!document.hidden) play();
      });

      var rescue = function () {
        if (v.__wlRescued || v.readyState > 0) return;
        v.__wlRescued = true;
        fetch(path)
          .then(function (r) { return r.blob(); })
          .then(function (bl) {
            v.src = URL.createObjectURL(bl.type ? bl : new Blob([bl], { type: 'video/mp4' }));
            v.muted = true;
            v.loop = true;
            play();
          })
          .catch(function () {});
      };
      v.addEventListener('error', rescue);
      setTimeout(rescue, 2200);
    });
  }

  /* ----------------------------------------------------------- mobile menu */
  function initDrawer() {
    var drawer = document.querySelector('[data-wl-drawer]');
    if (!drawer) return;
    var open = function () { drawer.classList.add('wl-drawer--open'); document.body.style.overflow = 'hidden'; };
    var close = function () { drawer.classList.remove('wl-drawer--open'); document.body.style.overflow = ''; };
    Array.prototype.forEach.call(document.querySelectorAll('[data-wl-drawer-open]'), function (b) {
      b.addEventListener('click', open);
    });
    Array.prototype.forEach.call(drawer.querySelectorAll('[data-wl-drawer-close]'), function (b) {
      b.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* ------------------------------------------------------------------ toast */
  var toastTimer;
  function toast(name) {
    var el = document.querySelector('[data-wl-toast]');
    if (!el) return;
    var slot = el.querySelector('[data-wl-toast-name]');
    if (slot) slot.textContent = name || '';
    el.classList.add('wl-toast--on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('wl-toast--on'); }, 2800);
  }

  function setCartCount(n) {
    Array.prototype.forEach.call(document.querySelectorAll('[data-wl-cart-count]'), function (el) {
      el.textContent = n;
      if (n > 0) el.removeAttribute('hidden');
      else el.setAttribute('hidden', '');
    });
  }

  /* ------------------------------------------------------------ add to cart */
  function initAddToCart() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-wl-add]'), function (form) {
      form.addEventListener('submit', function (e) {
        if (!window.fetch) return; /* let the plain POST through */
        e.preventDefault();
        var btn = form.querySelector('button');
        var label = btn ? btn.textContent : '';
        if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({
            id: form.querySelector('[name="id"]').value,
            quantity: 1
          })
        })
          .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error((res.data && res.data.description) || 'Unable to add');
            toast(form.getAttribute('data-wl-add') || '');
            return fetch('/cart.js').then(function (r) { return r.json(); });
          })
          .then(function (cart) {
            if (cart) setCartCount(cart.item_count);
            /* keep Dawn's own cart UI in step if it is on the page */
            var drawer = document.querySelector('cart-drawer, cart-notification');
            if (drawer && typeof drawer.onCartUpdate === 'function') drawer.onCartUpdate();
            document.dispatchEvent(new CustomEvent('wl:cart:added'));
          })
          .catch(function (err) {
            toast((err && err.message) || 'Unable to add');
          })
          .then(function () {
            if (btn) { btn.disabled = false; btn.textContent = label; }
          });
      });
    });
  }

  function boot() {
    initReveals(document);
    initHeader();
    initVideo();
    initDrawer();
    initAddToCart();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  /* theme editor: re-bind when a section is re-rendered */
  document.addEventListener('shopify:section:load', function (e) {
    initReveals(e.target);
    initHeader();
    initVideo();
    initDrawer();
    initAddToCart();
  });
})();
